import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../../../../services/account/account.service';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListResponse } from '../../../../../../models/list-response';
import {
  PotentialDuplicateCustomer,
  PotentialDuplicateCustomerFilters,
  PotentialDuplicateCustomerStatus
} from '../../../../../../models/inbox';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { LocalStorage } from 'angular-web-storage';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../utils';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';
import {
  ViewPotentialDuplicateCustomersModalComponent
} from './modals/view-potential-duplicate-customer-modal/view-potential-duplicate-customer-modal.component';


@Component({
  selector: 'app-inbox-potential-duplicate-customers',
  templateUrl: './inbox-potential-duplicate-customers.component.html',
  styleUrls: ['./inbox-potential-duplicate-customers.component.css']
})
export class InboxPotentialDuplicateCustomersComponent implements OnInit {
  public pageNumber = 1;
  @LocalStorage() public potentialDuplicateCustomersPageSize;
  public filters: PotentialDuplicateCustomerFilters = {
    status: PotentialDuplicateCustomerStatus.pendingAction
  };

  public inboxResponse: ListResponse<PotentialDuplicateCustomer>;

  public loadingInbox = true;

  public reloadSubject = new Subject<void>();

  public serverError: number = null;

  // The most recent result returned from a modal.
  public modalResult: CallbackResult = null;

  public readonly PotentialDuplicateCustomerStatus = PotentialDuplicateCustomerStatus;
  public readonly CallbackResultStatus = CallbackResultStatus;
  public readonly timeStringFromISO8601 = timeStringFromISO8601;
  public readonly dateStringFromISO8601 = dateStringFromISO8601;

  private requestCount = 0;

  constructor(
    public accountService: AccountService,
    public inboxService: InboxService,
    public orgConfig: OrganizationConfigService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.potentialDuplicateCustomersPageSize) {
      this.potentialDuplicateCustomersPageSize = 10;
    }
    // This is needed in order for the pageSize to be updated when the html
    // select is first changed.
    // noinspection SillyAssignmentJS
    this.potentialDuplicateCustomersPageSize = this.potentialDuplicateCustomersPageSize;

    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.reloadSubject.pipe(
      map(() => { this.loadingInbox = true; }),
      debounceTime(300)
    ).subscribe(() => {
      this.loadInbox();
    });

    this.loadInbox();
    this.inboxService.loadInboxCounts(true).then();
  }

  public resultsPresent() {
    return this.inboxResponse && (this.inboxResponse.count > 0);
  }

  public openModal(dup: PotentialDuplicateCustomer) {
    this.modalResult = null;

    const modalRef = this.modalService.open(ViewPotentialDuplicateCustomersModalComponent);
    modalRef.componentInstance.dupId = dup.id;
    modalRef.componentInstance.showHideOption = true;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.reloadSubject.next();
    };
  }

  /**
   * Get the number of the last page of results.
   */
  public lastPageNumber() {
    if (!this.resultsPresent()) { return 1; }
    return Math.ceil(this.inboxResponse.count / this.potentialDuplicateCustomersPageSize);
  }

  private loadInbox() {
    this.loadingInbox = true;

    this.requestCount++;
    const thisRequestCount = this.requestCount;

    this.inboxService
      .getPotentialDuplicateCustomers(
        this.pageNumber,
        this.potentialDuplicateCustomersPageSize,
        this.filters,
        true
      )
      .then(response => {
        if (thisRequestCount === this.requestCount) {
          this.inboxResponse = response;
        }
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        if (thisRequestCount === this.requestCount) {
          this.loadingInbox = false;
        }
      });
  }
}
